import React, { useEffect, useState } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { NewArrivalBanner } from './components/NewArrivalBanner';
import { OffersSection } from './components/OffersSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductsSection } from './components/ProductsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ShippingSection } from './components/ShippingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { LocationSection } from './components/LocationSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { InstagramButton } from './components/InstagramButton';
export function App() {
  const [activeBrand, setActiveBrand] = useState<string | null>(null);
  useEffect(() => {
    document.title = 'AlphaFit';
  }, []);
  return <div className="min-h-screen bg-dark-900 text-[#f0f0f0] font-sans overflow-x-hidden selection:bg-alphaGold selection:text-white" data-id="element-0" data-mp="3rcsy3udgkeef">
      <UrgencyBar data-id="element-1" data-mp="7stte3h7l4p" />
      <Navbar onBrandFilter={setActiveBrand} data-id="element-2" data-mp="2zld4hgdhhrep" />
      <main data-id="element-3" data-mp="2zmo5j8fjol24">
        <HeroSection data-id="element-4" data-mp="2zn6actg9w7ln" />
        <NewArrivalBanner data-id="element-5" data-mp="33movnqc0akp0" />
        <OffersSection data-id="element-6" data-mp="33lwzadal4ixo" />
        <PainSection data-id="element-7" data-mp="33n6zp94wu37h" />
        <SolutionSection data-id="element-8" data-mp="33orjq4tlm3r3" />
        <ProductsSection activeBrand={activeBrand} onBrandFilter={setActiveBrand} data-id="element-9" data-mp="38m1gy6n8bjph" />
        <BenefitsSection data-id="element-10" data-mp="3dle30p6a0mr0" />
        <ShippingSection data-id="element-11" data-mp="3dlnukh6yz1yt" />
        <TestimonialsSection data-id="element-12" data-mp="3diruonbka37q" />
        <AboutSection data-id="element-13" data-mp="nvsup6ui4rx0" />
        <FAQSection data-id="element-14" data-mp="nwc5m3lqig1j" />
        <LocationSection data-id="element-15" data-mp="nv0zhx4tgw79" />
        <FinalCTA data-id="element-16" data-mp="nxn9e3f6jnsn" />
      </main>
      <Footer data-id="element-17" data-mp="su44xiopl4fr" />
      <InstagramButton data-id="element-18" data-mp="stubfl4ggf5b" />
      <ScrollToTop data-id="element-19" data-mp="st2iki28sviq" />
    </div>;
}